export default "__VITE_ASSET__DoPSZbDR__"